<template>
    <div class="p-search-modal__keywords">
        <div v-if="showTitle" class="p-search-modal__keywords__title" >{{title}}</div>
        <div :class="{'p-search-modal__keywords__list': !showTitle}">
            <ul>
                <li v-for="word in keywords" :key="word.id" @click="chooseKeyword(word.title)"><a href="#">{{word.title}}</a></li>
            </ul>
        </div>
    </div>
</template>

<script setup>
defineProps({
  title: { default: '', type: String },
  keywords: {default: ()=>{return []}, type: Array},
  showTitle: { default: false, type: Boolean },
})

const emit = defineEmits(['choose-keyword'])

const chooseKeyword = (keyword) => {
    emit('choose-keyword', keyword)
}
</script>